import { purchaseApi as defaultPurchaseApi } from "@b2bportal/purchase-api";
import axios from "axios";

export const purchaseApi = defaultPurchaseApi(axios);
